import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

// The postcard that came back. 404 uses the same stamp language as the
// shared-trip postcard, so a dead link still feels like part of the product.
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-paper-deep px-5 py-16">
      <div className="w-full max-w-md bg-paper border border-rule p-10 text-center card-soft">
        <span
          className="inline-block border-2 border-danger text-danger px-4 py-2 -rotate-6 mb-8"
          aria-hidden="true"
        >
          <span className="kicker block leading-tight">returned</span>
          <span className="font-serif text-3xl leading-none">404</span>
        </span>
        <h1 className="font-serif text-3xl text-ink">
          This page didn't make it.
        </h1>
        <p className="font-serif text-ink-muted mt-3 leading-relaxed">
          The link may be old, or the trip it pointed at is gone.
        </p>
        <Link
          to="/"
          className="kicker inline-flex items-center min-h-[44px] px-7 mt-8 bg-ink text-paper hover:bg-ink-soft transition-colors"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
